
import { PayrollType } from "@/types/enums.type";
import { OfficeDto } from "@/types/office.type";
import { Component, Vue, Prop } from "vue-property-decorator";
import { mapState } from "vuex";
import { OpenShift } from "../shift.types";

@Component({
  computed: {
    ...mapState("Shift", ["selectedOffice"])
  }
})
export default class OpenCard extends Vue {
  @Prop() shift!: OpenShift;

  selectedOffice!: OfficeDto;

  getClasses(val: boolean): string[] {
    return val ? ['fas', 'fa-check-circle'] : ['far', 'fa-circle'];
  }

  get eodValue(): boolean {
    return this.selectedOffice.payroll?.type === PayrollType.EndOfDay;
  }

  get details(): string {
    return [
      this.shift.date.toLocaleDateString("en-US", {
        weekday: 'long',
        month: 'numeric',
        year: 'numeric',
        day: 'numeric'
      }),  
      this.shift.position,
      this.shift.time,
      this.shift.rate
    ].join(' · ')
  }

  onDelete(): void {
    this.$emit('delete');
  }
}
